import { MenuItem, TextField } from "@mui/material";
import t from "./translations";

interface RegionFilterSelectProps {
  regionTags: string[];
  value: string;
  onChange: (value: string) => void;
  testId: string;
}

export default function RegionFilterSelect({
  regionTags,
  value,
  onChange,
  testId,
}: RegionFilterSelectProps) {
  return (
    <TextField
      select
      size="small"
      label={t.RegionLabel}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      slotProps={{
        htmlInput: { "data-testid": testId },
        select: { displayEmpty: true },
        inputLabel: { shrink: true },
      }}
      sx={{ "& .MuiSelect-select": { width: "3ch", minWidth: "3ch" } }}
    >
      <MenuItem value="">{t.AllRegionsOption}</MenuItem>
      {regionTags.map((tag) => (
        <MenuItem key={tag} value={tag}>
          {tag}
        </MenuItem>
      ))}
    </TextField>
  );
}
